import { Observable, of } from 'rxjs';
import { catchError, merge } from 'rxjs/operators';

import { Movement, movementSelectors } from '@skinsoft/entity';
import { HistoryRecord } from '@skinsoft/ui';
import { resolveAuthor } from '../../resolve-author';

export function toHistoryRecord$(movement: Movement): Observable<HistoryRecord> {
    const featured: HistoryRecord = {
        author: movementSelectors.author(movement),
        date: movementSelectors.endDate(movement),
        description: movementSelectors.title(movement),
        id: movement.id,
        title: movementSelectors.incrementalTitle(movement),
    };

    const featured$ = of(featured);

    return featured$.pipe(
        merge(of({ ...featured, author: null } as HistoryRecord), featured$.pipe(resolveAuthor)),
        catchError(error => of({ ...featured, author: error })),
    );
}
